
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import VPNSection from './components/VPNSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import SupportSection from './components/SupportSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <VPNSection />
        <FeaturesSection />
        <AboutSection />
        <CTASection />
        <ContactSection />
        <SupportSection />
      </main>
      <Footer />
    </div>
  );
}
